<form #form="ngForm">
    <mat-card>
        <mat-card-title>
            <span [translate]="'admin.entreprise.utilisateurs.parametres.internesParams.title'"></span>
        </mat-card-title>
        <mat-card-content>
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="autoriserAdressePerso"
                        name="autoriserAdressePerso"
                        customType="checkbox"
                        [ngModel]="internesParams.autoriserAdressePerso"
                        [(customModel)]="internesParams.autoriserAdressePerso"
                        libelle="admin.entreprise.utilisateurs.parametres.internesParams.autoriser"
                        postLibelle="admin.entreprise.utilisateurs.parametres.internesParams.autoriserAdressePerso">
                </custom-input>
                <custom-input
                        ngDefaultControl
                        id="autoriserAdressePro"
                        name="autoriserAdressePro"
                        customType="checkbox"
                        [ngModel]="internesParams.autoriserAdressePro"
                        [(customModel)]="internesParams.autoriserAdressePro"
                        postLibelle="admin.entreprise.utilisateurs.parametres.internesParams.autoriserAdressePro">
                </custom-input>
            </div>
        </mat-card-content>
    </mat-card>
</form>